module.exports = __webpack_public_path__ + "img/-1.510c32d9.png";